module.exports = __webpack_public_path__ + "static/media/mobile-open.5708dcac.svg";